import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import {
  fetchUser,
  isValidTRC20AddressLength,
} from "../../../../helpers/helper";
import { useSelector, useDispatch } from "react-redux";
import { storeUser } from "../../../../redux/users/usersSlice";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { globalAllLeaderCommunities } from "../../../../store/globalstore";
import { useAtom } from "jotai";

const Payout = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [usdtWalletAddress, setUsdtWalletAddress] = useState("");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const verifiedmyTrade = !!(
    user?.verifiedmyTrade?.payment ||
    user?.verifiedmyTrade?.subscription?.subscriptionId
  );
  const api = useApi();
  const navigate = useNavigate();
  const [allLeaderCommunities, _] = useAtom(globalAllLeaderCommunities);

  const updateVerifyStatus = async () => {
    setIsLoading(true);

    try {
       const response = await api(
        "post",
        "authorizeNewonBoard/updateVerifyStatus",
        {
          onboarding: {
            community: [
              {
                id: user?.leaderCommunity?._id,
                message: "On boarding complete",
              },
            ],
            isVerified: true,
          },
          firstVisit: false,
          // "onboarding.subscribed": false,
          // "onboarding.connect": false,
          // "onboarding.payment": false,
          // "onboarding.isCommunityCreated": false,
        }
      );
      if(response?.status){
        // showNotificationToast("Copy trading is active!", `Your copy trading service is live and ready to share 🚀\n\nYour community can now copy your trades in just a few clicks. Once they sign up, connect, and subscribe—they’re trading what you trade.\n\nShare your landing page to start growing: ${response?.data?.businessUrls}\n\nTip:\n> Auto-share results to Telegram, Discord, or X. \n> Verify your performance for full transparency`);
      }
    } catch (error) {
      console.error("🚀 -> handleVerify -> error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNext = async () => {
    if (!usdtWalletAddress) {
      toastify("Wallet address can't empty");
      return;
    } else if (!isValidTRC20AddressLength(usdtWalletAddress)) {
      toastify("Please enter a valid Wallet Address");
      return;
    }

    setIsLoading(true);

    try {
      // if (user?.tradeName&&allLeaderCommunities?.length === 1 && verifiedmyTrade) {
      //   await updateVerifyStatus();
      // }

      const onboarding = {
        ...user?.onboarding,
        community: [
          {
            id: user?.leaderCommunity?._id,
            message: "On boarding complete",
          },
        ],
        isVerified: true,
      };

      const response = await api("post", "users/update", {
        getPaidInCrypto: true,
        getPaidInUSD: false,
        usdtWalletAddress,
        firstVisit: true,
        ...(allLeaderCommunities?.length > 1 && { onboarding }),
      });

      if (response?.status) {
        
        // if (user?.tradeName&&allLeaderCommunities?.length === 1 && verifiedmyTrade) {
        if (user?.tradeName||(!user?.tradeName&&allLeaderCommunities.length>1)) {      
        await updateVerifyStatus();
        // const responseUser = await api("get", "users/index");
        // if (responseUser?.status) {
        //   const { data } = responseUser;
        //   if (dispatch && storeUser) dispatch(storeUser(data));
        //   if (data?.token) localStorage.setItem("token", data.token);
        // }
       
        // await Promise.all([fetchUser(api, dispatch, storeUser), updateVerifyStatus()]);
          navigate("/leader/onboarding/alldone", { replace: true, state: { from: "onboarding" } });  
          return;
        }
        await Promise.all([fetchUser(api, dispatch, storeUser), sendOtp()]);

        if (user?.socialLogin?.discord?.id) {
          navigate("/leader/onboarding/importantUpdates", { replace: true , state: { from: "onboarding" } });
        } else if (user?.socialLogin?.telegram?.id) {
          navigate("/leader/onboarding/submitNewEmail", { replace: true , state: { from: "onboarding" } });
        } else {
          //
          navigate("/leader/onboarding/verify", { replace: true , state: { from: "onboarding" } });
        }
      } else toastify(response?.message, "error");
    } catch (error) {
      console.error("🚀 -> handleNext -> error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const sendOtp = async () => {
    try {
      await api("post", "authorizeNewonBoard/sendOtp");
    } catch (error) {
      console.error("🚀 -> sendOtp -> error:", error);
    }
  };

  useEffect(() => {
    if (user?.usdtWalletAddress) {
      setUsdtWalletAddress(user?.usdtWalletAddress);
    }
  }, []);

  return (
    <div className="onboardingContentBox top73px">
      <h2 className="title">
        <span>Wallet address for payouts</span>
        <InfoPopup
          contentItems={[
            { text: "Wallet address", type: "heading" },
            {
              text: `Enter a wallet address to receive USDT payouts (TRC20 network only).
Please double-check the address — we can’t recover funds sent to an incorrect wallet.

You can update this later after sign-up.`,
              type: "paragraph",
            },
          ]}
        />
      </h2>
      <p className="desc bottom50px">Submit wallet to receive USDT (TRC20)</p>
      <div className="formBox">
        <div className="mb-20px">
          <FloatingTextFiled
            className="onboardingInput"
            label="Wallet address (TRC20)"
            onChange={(e) => setUsdtWalletAddress(e.target.value)}
            placeholder="Wallet address (TRC20)"
            value={usdtWalletAddress}
          />
        </div>

        <BubbleSvgButton
          className="NextBtn"
          onClick={handleNext}
          disabled={isLoading}
          isLoading={isLoading}
          text={"Next"}
          type="button"
          variant="black"
          containerStyling={{
            justifyContent: "center",
          }}
          mainDivStyle={{
            width: "275px",
            height: "55px",
          }}
        />
      </div>
    </div>
  );
};

export default Payout;
